import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ControlPosition } from "react-draggable";

export type DocumentLayoutType = "image-left" | "image-right";
/** Rozložení formuláře detailu dokladu: původní (classic) nebo nové po sekcích (sections) */
export type DocumentFormLayoutType = "classic" | "sections";
export type DocumentSettings = {
    layout: DocumentLayoutType;
    confirmType: "confirm" | "confirmAndGoToNext";
    documentItemSaveType: "save" | "saveAndContinue";
    formLayout: DocumentFormLayoutType;
};
export type ApplicationSettingsState = {
    document: DocumentSettings;
    dialogPositions: Record<string, ControlPosition>;
};

const initialState: ApplicationSettingsState = {
    document: {
        layout: "image-right",
        confirmType: "confirm",
        documentItemSaveType: "save",
        formLayout: "classic",
    },
    dialogPositions: {
        taxDocumentItemFormDialog: { x: 0, y: 0 },
    },
};

export const taxSettingsSlice = createSlice({
    name: "taxAppSettings",
    initialState,
    reducers: {
        patchDocumentSettings: (state, action: PayloadAction<Partial<ApplicationSettingsState["document"]>>) => {
            state.document = {
                ...state.document,
                ...action.payload,
            };
        },
        initState: (state, action: PayloadAction<Partial<ApplicationSettingsState>>) => {
            state.document = { ...state.document, ...action.payload.document };
            state.dialogPositions = { ...state.dialogPositions, ...action.payload.dialogPositions };
        },
        saveDialogPosition: (state, action: PayloadAction<{ dialogId: string; position: ControlPosition }>) => {
            const { dialogId, position } = action.payload;
            state.dialogPositions = {
                ...state.dialogPositions,
                [dialogId]: position,
            };
        },
    },
});

export const { patchDocumentSettings, initState, saveDialogPosition } = taxSettingsSlice.actions;

export default taxSettingsSlice.reducer;
